export default "__VITE_ASSET__Cj9oVi3x__"